/**
 * Javascript for single view of ige_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 * 
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

/**
 * Load external JavaScript Libaries
 */
var $           = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks    = require('../../../../../../../webpack/node_modules/nunjucks');
var basket      = require("./basket.js");
var translation = require("./translation.js");

/**
 * Global vars
 */
var container = ".psr-shop-product";

/**
 * Initialize the application
 */
if (window.srcSingleJson) {
    showProduct(window.srcSingleJson);
    basket.showBasket();
}

/**
 * Generate single view
 */
function showProduct(jsonOnPage) {
    // The JSON informations
    var product = jsonOnPage; // Get the JSON with the products

    // Initialize Nunjucks
    nunjucks.configure('/template/dist/views-shop', {autoescape: true});

    translations = {
        "sum-total": translation.getTranslation("sum-total"),
        "price": translation.getTranslation("price"),
        "quantity": translation.getTranslation("quantity"),
        "checkout": translation.getTranslation("checkout"),
        "back": translation.getTranslation("back"),
        "remove": translation.getTranslation("remove"),
        "basket": translation.getTranslation("basket"),
        "highlights": translation.getTranslation("highlights"),
        "order": translation.getTranslation("order"),
        "intobasket": translation.getTranslation("into-basket"),
        "description": translation.getTranslation("description"),
        "baskethelp": translation.getTranslation("basket-help"),
        "available": translation.getTranslation("available"),
        "notavailable": translation.getTranslation("notavailable"),
        "tabDescription": translation.getTranslation("tab-description"),
        "tabHighlights": translation.getTranslation("tab-highlights"),
        "tabOrder": translation.getTranslation("tab-order"),
        "allInfos": translation.getTranslation("all-infos"),
        'vat': translation.getTranslation("vat")
    };


    var productDescription = product.description;
    product.description = encodeURI(product.description);

    // Create View
    //var view = nunjucks.render('item.twig', {translations: translations, product: product, uid: product.uid, title: product.title, price: translation.currencyFormatter(product.price), available: product.available, images: product.images, highlights: product.highlights, uri: product.uri, deliveryInformation: product.deliveryInformation, additionalPriceInformation: product.additionalPriceInformation, description: product.description});

    var displayPrice = product.price.toFixed(2);
    // Create View
    var showVat = window.showVat;
    var view = nunjucks.render('item.twig', {currency: currency, translations: translations, product: product, uid: product.uid, title: product.title, price: displayPrice, available: product.available, images: product.images, highlights: product.highlights, uri: product.uri, deliveryInformationTitle: product.deliveryInformationTitle, deliveryInformation: product.deliveryInformation, additionalPriceInformation: product.additionalPriceInformation, description: productDescription, showVat: showVat});
    
    $(container).html(view);

    $('.order-button').click(function() {
        var btn = $(this);
        var quantity = $('input#psr-shop-numberItemsToOrder', $(btn).parent()).val();
        var popupText = translation.getTranslation('product-added-to-filter');
        if (quantity < 1){
            popupText = translation.getTranslation('product-added-to-filter-noquantity');
        }
        else {
            basket.order($(this).data('product'), parseInt($('.psr-shop-numberItemsToOrder').val()), $(this).data('uid'));
        }
        $(btn).after('<p class="basket-message">' + popupText + '</p>');
        var temp = $('p.basket-message', $(btn).parent());
        $(temp).hide().fadeIn('200');
        setTimeout(function () {
            $(temp).fadeOut('200', function(){ $(temp).remove(); });
        }, 5000);
    });

    $('.shop-basket-toggle').click(function() {
        $('.shop-basket-flyout').toggleClass('open');
        $(this).toggleClass('open');
    });
}
